module.exports = __webpack_public_path__ + "static/lenbrook-logo-8e5d2cc620099fe29c783c31ff8659b6.jpg";